// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import ClassStep from "./class-step.js"
import Contact from "./contact.js"
import School from "./school.js"
import SchoolClassCheckIn from "./school-class-check-in.js"
import SchoolClassCourse from "./school-class-course.js"
import Subscription from "./subscription.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "class_step_id": {
      "column": {
        "default": null,
        "name": "class_step_id",
        "null": true,
        "type": null
      },
      "name": "class_step_id",
      "selected_by_default": null,
      "translated": null
    },
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": null
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "interpreted_legal_name": {
      "column": null,
      "name": "interpreted_legal_name",
      "selected_by_default": null,
      "translated": null
    },
    "interpreted_name": {
      "column": null,
      "name": "interpreted_name",
      "selected_by_default": null,
      "translated": null
    },
    "legal_name": {
      "column": {
        "default": null,
        "name": "legal_name",
        "null": true,
        "type": "string"
      },
      "name": "legal_name",
      "selected_by_default": null,
      "translated": null
    },
    "school_class_check_ins_count": {
      "column": {
        "default": "0",
        "name": "school_class_check_ins_count",
        "null": false,
        "type": "integer"
      },
      "name": "school_class_check_ins_count",
      "selected_by_default": null,
      "translated": null
    },
    "school_id": {
      "column": null,
      "name": "school_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "has_pro_subscription": {
      "column": null,
      "name": "has_pro_subscription",
      "selected_by_default": false,
      "translated": null
    },
    "viewed_class_space_today": {
      "column": null,
      "name": "viewed_class_space_today",
      "selected_by_default": false,
      "translated": null
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": null
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": null
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": null
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": null
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "SchoolClass",
  "collectionKey": "school_classes",
  "collectionName": "school_classes",
  "i18nKey": "school_class",
  "camelizedLower": "schoolClass",
  "name": "SchoolClass",
  "nameDasherized": "school-class",
  "pluralName": "school_classes",
  "ransackable_associations": [
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "active_subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": "contact"
    },
    {
      "className": "SchoolClass::Audit",
      "collectionName": "school_class_audits",
      "foreignKey": "school_class_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SchoolClassAudit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "current_school_class_id",
      "name": "audits_as_school_class",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "belongs_to",
      "resource_name": "ClassStep",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "SchoolClass::Audit",
      "collectionName": "school_class_audits",
      "foreignKey": "school_class_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SchoolClassAudit",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "School",
      "through": "school_contact"
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "school_class_id",
      "name": "school_class_check_ins",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    },
    {
      "className": "SchoolClassContentPiece",
      "collectionName": "school_class_content_pieces",
      "foreignKey": "school_class_id",
      "name": "school_class_content_pieces",
      "macro": "has_many",
      "resource_name": "SchoolClassContentPiece",
      "through": null
    },
    {
      "className": "SchoolClassCourse",
      "collectionName": "school_class_courses",
      "foreignKey": "school_class_id",
      "name": "school_class_courses",
      "macro": "has_many",
      "resource_name": "SchoolClassCourse",
      "through": null
    },
    {
      "className": "SchoolClassGroup",
      "collectionName": "school_class_groups",
      "foreignKey": "school_class_group_id",
      "name": "school_class_groups",
      "macro": "has_many",
      "resource_name": "SchoolClassGroup",
      "through": "class_step"
    },
    {
      "className": "SchoolClassInvitation",
      "collectionName": "school_class_invitations",
      "foreignKey": "resource_id",
      "name": "school_class_invitations",
      "macro": "has_many",
      "resource_name": "SchoolClassInvitation",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "school_contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "school_parent_relationship"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "child_id",
      "name": "school_parent_relationship",
      "macro": "has_one",
      "resource_name": "ContactRelationship",
      "through": "contact"
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": "contact"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "teacher_contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "contact"
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "contact_id",
      "name": "teachers",
      "macro": "has_many",
      "resource_name": "User",
      "through": "teacher_contacts"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_id",
      "name": "team_surveys",
      "macro": "has_many",
      "resource_name": "TeamSurvey",
      "through": "teams"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "school_class_id",
      "name": "teams",
      "macro": "has_many",
      "resource_name": "Team",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "class_step_id",
      "column": {
        "default": null,
        "name": "class_step_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "legal_name",
      "column": {
        "default": null,
        "name": "legal_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "school_class_check_ins_count",
      "column": {
        "default": "0",
        "name": "school_class_check_ins_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "school_id_deprecated",
      "column": {
        "default": null,
        "name": "school_id_deprecated",
        "null": true,
        "type": null
      }
    },
    {
      "name": "subscriptions_count",
      "column": {
        "default": "0",
        "name": "subscriptions_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "has_woofed_this_week"
    },
    {
      "name": "hasnt_woofed_this_week_but_within_last_year"
    },
    {
      "name": "school_role_for"
    },
    {
      "name": "where_user_is_a"
    },
    {
      "name": "where_user_related_through_anything"
    },
    {
      "name": "with_active_subscription"
    },
    {
      "name": "with_contact_id"
    },
    {
      "name": "with_data_insights_for"
    }
  ],
  "relationships": [
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "active_subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": "contact"
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "belongs_to",
      "resource_name": "ClassStep",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "School",
      "through": "school_contact"
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "school_class_id",
      "name": "school_class_check_ins",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    },
    {
      "className": "SchoolClassCourse",
      "collectionName": "school_class_courses",
      "foreignKey": "school_class_id",
      "name": "school_class_courses",
      "macro": "has_many",
      "resource_name": "SchoolClassCourse",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "contact_id",
      "name": "teachers",
      "macro": "has_many",
      "resource_name": "User",
      "through": "teacher_contacts"
    }
  ],
  "paramKey": "school_class",
  "primaryKey": "id"
}

/** Frontend model for SchoolClass. */
export default class SchoolClass extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any | null} */
  classStepId() {
    return this.readAttributeUnderscore("class_step_id")
  }

  /** @returns {boolean} */
  hasClassStepId() {
    const value = this.classStepId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  interpretedLegalName() {
    return this.readAttributeUnderscore("interpreted_legal_name")
  }

  /** @returns {boolean} */
  hasInterpretedLegalName() {
    const value = this.interpretedLegalName()

    return this._isPresent(value)
  }

  /** @returns {any} */
  interpretedName() {
    return this.readAttributeUnderscore("interpreted_name")
  }

  /** @returns {boolean} */
  hasInterpretedName() {
    const value = this.interpretedName()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  legalName() {
    return this.readAttributeUnderscore("legal_name")
  }

  /** @returns {boolean} */
  hasLegalName() {
    const value = this.legalName()

    return this._isPresent(value)
  }

  /** @returns {number} */
  schoolClassCheckInsCount() {
    return this.readAttributeUnderscore("school_class_check_ins_count")
  }

  /** @returns {boolean} */
  hasSchoolClassCheckInsCount() {
    const value = this.schoolClassCheckInsCount()

    return this._isPresent(value)
  }

  /** @returns {any} */
  schoolId() {
    return this.readAttributeUnderscore("school_id")
  }

  /** @returns {boolean} */
  hasSchoolId() {
    const value = this.schoolId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  hasProSubscription() {
    return this.readAttributeUnderscore("has_pro_subscription")
  }

  /** @returns {boolean} */
  hasHasProSubscription() {
    const value = this.hasProSubscription()

    return this._isPresent(value)
  }

  /** @returns {any} */
  viewedClassSpaceToday() {
    return this.readAttributeUnderscore("viewed_class_space_today")
  }

  /** @returns {boolean} */
  hasViewedClassSpaceToday() {
    const value = this.viewedClassSpaceToday()

    return this._isPresent(value)
  }

  /** @returns {any} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static classStatusData(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "class_status_data",
        collectionName: "school_classes",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static createNew(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "create_new",
        collectionName: "school_classes",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static insightsTopScoreFactor(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "insights_top_score_factor",
        collectionName: "school_classes",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static schoolLeaderCreate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "school_leader_create",
        collectionName: "school_classes",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static unicornFilterData(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "unicorn_filter_data",
        collectionName: "school_classes",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  adminDestroy(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "admin_destroy",
        primaryKey: this.primaryKey(),
        collectionName: "school_classes",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  invite(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "invite",
        primaryKey: this.primaryKey(),
        collectionName: "school_classes",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  randomCheckIn(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "random_check_in",
        primaryKey: this.primaryKey(),
        collectionName: "school_classes",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  randomCourse(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "random_course",
        primaryKey: this.primaryKey(),
        collectionName: "school_classes",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  registerView(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "register_view",
        primaryKey: this.primaryKey(),
        collectionName: "school_classes",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  softDelete(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "soft_delete",
        primaryKey: this.primaryKey(),
        collectionName: "school_classes",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  unicornEffects(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "unicorn_effects",
        primaryKey: this.primaryKey(),
        collectionName: "school_classes",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./subscription.js").default>} */
  activeSubscriptions() {
    return new Collection(
      {
        reflectionName: "active_subscriptions",
        model: this,
        modelClass: Subscription
      },
      {
        params: {
          through: {
            model: "SchoolClass",
            id: this.primaryKey(),
            reflection: "active_subscriptions"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./subscription.js").default>>} */
  loadActiveSubscriptions() {
    return this._loadHasManyReflection(
      {
        reflectionName: "active_subscriptions",
        model: this,
        modelClass: Subscription
      },
      {
        params: {
          through: {
            model: "SchoolClass",
            id: this.primaryKey(),
            reflection: "active_subscriptions"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./subscription.js").default>>} */
  ensureActiveSubscriptionsLoaded() {
    return this.ensureAssociationLoaded("active_subscriptions")
  }

  /** @returns {import("./class-step.js").default | null} */
  classStep() {
    return this._readBelongsToReflection({modelClass: ClassStep, reflectionName: "class_step"})
  }

  /** @returns {Promise<import("./class-step.js").default | null>} */
  loadClassStep() {
    if (!("classStepId" in this)) throw new Error("Foreign key method wasn't defined: classStepId")

    const id = this.classStepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "class_step",
        model: this,
        modelClass: ClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./class-step.js").default | null>} */
  ensureClassStepLoaded() {
    return this.ensureAssociationLoaded("class_step")
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./school.js").default | null} */
  school() {
    return this._readHasOneReflection({modelClass: School, reflectionName: "school"})
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  loadSchool() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "school",
        model: this,
        modelClass: School
      },
      {
        params: {
          through: {
            model: "SchoolClass",
            id,
            reflection: "school"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  ensureSchoolLoaded() {
    return this.ensureAssociationLoaded("school")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-check-in.js").default>} */
  schoolClassCheckIns() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["school_class_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_check_ins",
        model: this,
        modelClass: SchoolClassCheckIn
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-check-in.js").default>>} */
  loadSchoolClassCheckIns() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["school_class_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_check_ins",
        model: this,
        modelClass: SchoolClassCheckIn
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-check-in.js").default>>} */
  ensureSchoolClassCheckInsLoaded() {
    return this.ensureAssociationLoaded("school_class_check_ins")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class-course.js").default>} */
  schoolClassCourses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["school_class_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_class_courses",
        model: this,
        modelClass: SchoolClassCourse
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-course.js").default>>} */
  loadSchoolClassCourses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["school_class_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_class_courses",
        model: this,
        modelClass: SchoolClassCourse
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class-course.js").default>>} */
  ensureSchoolClassCoursesLoaded() {
    return this.ensureAssociationLoaded("school_class_courses")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./user.js").default>} */
  teachers() {
    return new Collection(
      {
        reflectionName: "teachers",
        model: this,
        modelClass: User
      },
      {
        params: {
          through: {
            model: "SchoolClass",
            id: this.primaryKey(),
            reflection: "teachers"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./user.js").default>>} */
  loadTeachers() {
    return this._loadHasManyReflection(
      {
        reflectionName: "teachers",
        model: this,
        modelClass: User
      },
      {
        params: {
          through: {
            model: "SchoolClass",
            id: this.primaryKey(),
            reflection: "teachers"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./user.js").default>>} */
  ensureTeachersLoaded() {
    return this.ensureAssociationLoaded("teachers")
  }
}
